import type { Animal } from './animal.interface';

export interface cv_BodyConditionScore {
    Abbreviation: string;
    Animal: Animal[];
    BodyConditionScore: string;
    C_BodyConditionScore_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    IsExitStatus: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number | null;
}
